<table-responsive
  table
  [length]="length"
  (changePage)="changePage($event)"
  (filter)="filter($event)"
  [displayedColumns]="displayedColumns"
  [dataSource]="dataSource"
  [configColumns]="configColumns"
  (openShow)="openShow($event)"
  (openNew)="openNew($event)"
  (openEdit)="openEdit($event)"
  (openDelete)="openDelete($event)"
></table-responsive>
<div footer>
  <div fxFlex fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="4">
    <div fxFlex></div>
    <div fxFlex>
      <button disabled class="action-button" mat-raised-button></button>
    </div>
    <div fxFlex>
      <button disabled class="action-button" mat-raised-button></button>
    </div>
    <div fxFlex>
      <button disabled class="action-button" mat-raised-button></button>
    </div>
    <div fxFlex></div>
  </div>
</div>
